<script>
	export let currentPage = 1;
	export let totalPages = 1;
	export let onPageChange;

	// 10페이지씩 묶음으로 표시
	const pagesPerGroup = 10;
	
	// 페이지 그룹 계산
	$: currentGroup = Math.ceil(currentPage / pagesPerGroup);
	$: totalGroups = Math.ceil(totalPages / pagesPerGroup);
	
	// 현재 그룹의 시작/끝 페이지
	$: groupStartPage = (currentGroup - 1) * pagesPerGroup + 1;
	$: groupEndPage = Math.min(currentGroup * pagesPerGroup, totalPages);
	
	// 표시할 페이지 배열
	$: visiblePages = Array.from(
		{ length: groupEndPage - groupStartPage + 1 }, 
		(_, i) => groupStartPage + i
	);
	
	// 버튼 상태 계산
	$: canGoPrevGroup = currentGroup > 1;
	$: canGoNextGroup = currentGroup < totalGroups;
	$: canGoFirst = currentPage > 1;
	$: canGoLast = currentPage < totalPages;
	
	// 이벤트 핸들러
	const goToPage = (page) => {
		if (page >= 1 && page <= totalPages) {
			onPageChange(page);
		}
	};
	
	const goToPrevGroup = () => {
		if (canGoPrevGroup) {
			const newPage = (currentGroup - 2) * pagesPerGroup + 1;
			goToPage(newPage);
		}
	};
	
	const goToNextGroup = () => {
		if (canGoNextGroup) {
			const newPage = currentGroup * pagesPerGroup + 1;
			goToPage(newPage);
		}
	};
</script>

{#if totalPages > 1}
	<div class="d-flex justify-content-center align-items-center mt-3 mb-3 gap-3">
		<!-- 페이지네이션 -->
		<nav>
			<ul class="pagination pagination-sm mb-0">
				<!-- 맨 처음으로 -->
				<li class="page-item {!canGoFirst ? 'disabled' : ''}">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a class="page-link d-flex align-items-center justify-content-center" 
					   href="javascript:void(0)" 
					   on:click|preventDefault={() => goToPage(1)}
					   title="첫 페이지"
					   style="width: 22px; height: 22px; padding: 0;">
						<i class="bx bx-chevrons-left" style="font-size: 10px;"></i>
					</a>
				</li>
				
				<!-- 이전 그룹 -->
				<li class="page-item {!canGoPrevGroup ? 'disabled' : ''}">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a class="page-link d-flex align-items-center justify-content-center" 
					   href="javascript:void(0)" 
					   on:click|preventDefault={goToPrevGroup}
					   title="이전 그룹"
					   style="width: 22px; height: 22px; padding: 0;">
						<i class="bx bx-chevron-left" style="font-size: 10px;"></i>
					</a>
				</li>
				
				<!-- 페이지 번호들 -->
				{#each visiblePages as page}
					<li class="page-item {currentPage === page ? 'active' : ''}">
						<!-- svelte-ignore a11y-invalid-attribute -->
						<a class="page-link d-flex align-items-center justify-content-center fw-medium" 
						   href="javascript:void(0)" 
						   on:click|preventDefault={() => goToPage(page)}
						   style="width: 22px; height: 22px; padding: 0; font-size: 10px;">
							{page}
						</a>
					</li>
				{/each}
				
				<!-- 다음 그룹 -->
				<li class="page-item {!canGoNextGroup ? 'disabled' : ''}">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a class="page-link d-flex align-items-center justify-content-center" 
					   href="javascript:void(0)" 
					   on:click|preventDefault={goToNextGroup}
					   title="다음 그룹"
					   style="width: 22px; height: 22px; padding: 0;">
						<i class="bx bx-chevron-right" style="font-size: 10px;"></i>
					</a>
				</li>
				
				<!-- 맨 끝으로 -->
				<li class="page-item {!canGoLast ? 'disabled' : ''}">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a class="page-link d-flex align-items-center justify-content-center" 
					   href="javascript:void(0)" 
					   on:click|preventDefault={() => goToPage(totalPages)}
					   title="마지막 페이지"
					   style="width: 22px; height: 22px; padding: 0;">
						<i class="bx bx-chevrons-right" style="font-size: 10px;"></i>
					</a>
				</li>
			</ul>
		</nav>
	</div>
{/if}
